<div class="container locker-date">
  <div class="row p-0 m-0 mb-4">
    <div class="col ms-auto me-auto">
      <h2 class="text-center">{{'lockerdate.title'|traduccion}}</h2>
    </div>
  </div>
  <div class="row section-block">
    @if (uniquePrice != null) {
      <div class="col">
        <app-block-date [class.inactive]="activeSection !== 'reservation'"
          showDetail="true"
          [minPrice]="minPrice"
          [minPeriod]="$safeNavigationMigration(uniquePrice?.minPeriod)"
          [maxPeriod]="$safeNavigationMigration(uniquePrice?.maxPeriod)"
        (callBack)="callBack($event)"></app-block-date>
      </div>
    }
    @if (subscriptions.length > 0) {
      <div class="col">
        <app-block-date [class.inactive]="activeSection !== 'subscription'"
          showDetail="true"
          [minPrice]="minPrice"
          [subscriptions]="subscriptions"
          activeSection="subscription"
        (callBack)="callBack($event)"></app-block-date>
      </div>
    }
  </div>
</div>